/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import s from './index.module.scss';
import ActionBar from '../../../components/actionBar';
import bgJpg from './img/bg.jpg';
import bgWebp from './img/bg.webp';
import bgDesctJpg from './img/bg_desktop.jpg';
import bgDesctWebp from './img/bg_desktop.webp';

function StartPage() {
  const [desktopMode, setDesktopMode] = useState(window.innerWidth > 430);

  useEffect(() => {
    function handleResize() {
      setDesktopMode(window.innerWidth > 430);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={s.startPage}>
      {desktopMode ? (
        <picture className={s.startPage_bg__desktop}>
          <source srcSet={bgDesctWebp} type="image/webp" />
          <img src={bgDesctJpg} alt="Layer" />
        </picture>
      ) : (
        <picture className={s.startPage_bg}>
          <source srcSet={bgWebp} type="image/webp" />
          <img src={bgJpg} alt="Layer" />
        </picture>
      )}
      <h2 className={s.startPage_header}>
        Woof-woof!<br /> Welcome to EveryDoggy!
      </h2>
      <p className={s.startPage_descroption}>
        Everything you need to socialize, train, and bond with your dog is now on one app.
      </p>
      <ActionBar currentStepCompleted show withShadow transparentBg />
    </div>
  );
}

export default StartPage;
